import { render } from "./sipAccountPrice.vue?vue&type=template&id=c29045aa&scoped=true"
import script from "./sipAccountPrice.vue?vue&type=script&lang=js"
export * from "./sipAccountPrice.vue?vue&type=script&lang=js"

import "./sipAccountPrice.vue?vue&type=style&index=0&id=c29045aa&scoped=true&lang=css"
import "./sipAccountPrice.vue?vue&type=style&index=1&id=c29045aa&lang=css"
script.render = render
script.__scopeId = "data-v-c29045aa"

export default script